
const state = {
  store_id: '',
  base64: null,
  mobileFilters: {
    product_filters: {
      product_category_hlev1_id: [],
      product_map_id: [],
      product_id: [],
      product_category_hlev2_id: [],
      product_category_hlev3_id: [],
      product_category_hlev4_id: [],
      color_id: [],
      brand_id: [],
      attr_1_id: [],
      attr_2_id: [],
      attr_3_id: [],
      obsolete: []
    }
  }
}

const getters = {
}

const mutations = {
  commit_store_id (state, id) {
    state.store_id = id
  },
  commit_base64 (state, string) {
    state.base64 = string
  },
  commit_newFilters (state, obj) {
    state.mobileFilters = obj
  }
}

const actions = {

}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/mobile.js